import { Button, Flex, FormControl, FormLabel, Input, Wrap, WrapItem, Text, Center } from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import axios from "axios";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { RepeatClockIcon } from "@chakra-ui/icons";


type SearchOptions = {
    companyId?: string,
    placeOfBusinessId?: string,
    ProviderId?: string,
    startDate?: string,
    endDate?: string
} | undefined

const BillSelects = (props: { searchAbleData: (data: SearchOptions) => void }) => {
    const [companies, setCompanies] = useState<{ value: string, label: string, colorScheme: string }[]>([]);
    const [providers, setProviders] = useState<{ value: string, label: string, colorScheme: string }[]>([]);
    const [placeOfBusiness, setPlaceOfBusiness] = useState<{ value: string, label: string, colorScheme: string }[]>([]);
    const [companyId, setCompanyId] = useState<string>("");
    const [searchOptions, setSearchOptions] = useState<SearchOptions>({})

    const { t } = useTranslation("translations");

    const fetchCompanies = async () => {
        try {
            const res = await getAxiosInstance().get(`/Companies`, {
                params: {
                    PageNumber: 1,
                    PageSize: 100
                }
            });

            setCompanies(res.data.map((x: any) => ({ value: x.id, label: x.name, colorScheme: "red" })));

        } catch (error) {
            if (axios.isAxiosError(error)) {
                toast.error(`${error.response?.data}`, { position: toast.POSITION.BOTTOM_RIGHT })
            } else {
                toast.error(t(`Could not retrieve the companies from the database!`), { position: toast.POSITION.BOTTOM_RIGHT });
            }
        }
    }

    const fetchPlaceOfBusiness = async () => {
        try {
            const res = await getAxiosInstance().get(`/Companies/company-place-of-business/${companyId}`);

            setPlaceOfBusiness(res.data.map((x: any) => ({ value: x.id, label: x.name, colorScheme: "red" })));

        } catch (error) {
            if (axios.isAxiosError(error) && error.response?.status !== 400) {
                toast.error(`${error.response?.data}`, { position: toast.POSITION.BOTTOM_RIGHT })
            }
        }
    }

    const fetchProvider = async () => {
        try {
            const res = await getAxiosInstance().get(`/Providers`, {
                params: {
                    PageNumber: 1,
                    PageSize: 100
                }
            });

            setProviders(res.data.map((x: any) => ({ value: x.id, label: x.name, colorScheme: "orange" })));

        } catch (error) {
            if (axios.isAxiosError(error)) {
                toast.error(`${error.response?.data}`, { position: toast.POSITION.BOTTOM_RIGHT })
            } else {
                toast.error(t(`Could not retrieve the providers from the database`), { position: toast.POSITION.BOTTOM_RIGHT });
            }
        }
    }


    useEffect(() => {
        fetchCompanies().then();
        fetchProvider().then();
    }, []);

    useEffect(() => {
        fetchPlaceOfBusiness().then();
    }, [companyId])

    useEffect(() => {
        props.searchAbleData(searchOptions)
    }, [searchOptions])

    return (
        <div className="flex flex-col md:flex-row justify-between" >
            <FormControl className="mx-2">
                <FormLabel>{t("SELECT_COMPANY")}</FormLabel>
                <Select
                    name={t("SELECT_COMPANY")}
                    options={companies}
                    placeholder={t("SELECT_COMPANY")}
                    value={searchOptions && searchOptions["companyId"] ? companies[companies?.findIndex((x) => x.value == searchOptions["companyId"])] : []}
                    onChange={(e: any) => {
                        if (e) {
                            setCompanyId(e.value);
                            setSearchOptions({ ...searchOptions, companyId: e.value })
                        }
                    }}
                />
            </FormControl>
            <FormControl className="mx-2">
                <FormLabel>{t("SELECT_PLACE_OF_BUSINESS")}</FormLabel>
                <Select
                    name={t("SELECT_PLACE_OF_BUSINESS")}
                    options={placeOfBusiness}
                    value={searchOptions && searchOptions["placeOfBusinessId"] ? placeOfBusiness[placeOfBusiness.findIndex(x => x.value === searchOptions["placeOfBusinessId"])] : []}
                    onChange={
                        (e) => {
                            if (e) setSearchOptions({ ...searchOptions, placeOfBusinessId: e.value })
                        }
                    }
                    placeholder={t("SELECT_PLACE_OF_BUSINESS")}
                />
            </FormControl>

            <FormControl className="mx-2">
                <FormLabel>{t("SELECT_PROVIDER")}</FormLabel>
                <Select
                    name={t("SELECT_PROVIDER")}
                    options={providers}
                    value={searchOptions && searchOptions["ProviderId"] ? providers[providers.findIndex((x) => x.value === searchOptions["ProviderId"])] : []}
                    placeholder={t("SELECT_PROVIDER")}
                    onChange={
                        (e) => {
                            if (e) setSearchOptions({ ...searchOptions, ProviderId: e.value })
                        }
                    }
                />
            </FormControl>

            <FormControl className="mx-2">
                <FormLabel>{t("START_DATE")}</FormLabel>
                <Input
                    isRequired
                    type="date"
                    name='Start Date'
                    value={searchOptions && searchOptions["startDate"] !== "" ? searchOptions["startDate"] : " "}
                    onChange={
                        (e) => {
                            if (e) setSearchOptions({ ...searchOptions, startDate: e.target.value })
                        }
                    }
                    placeholder={t("BILL_DATE_INPUT_PLACEHOLDER")}
                />
            </FormControl>
            <FormControl className="mx-2">
                <FormLabel>{t("END_DATE")}</FormLabel>
                <Input
                    isRequired
                    type="date"
                    name="End Date"
                    value={searchOptions && searchOptions["endDate"] !== "" ? searchOptions["endDate"] : " "}
                    onChange={
                        (e) => {
                            if (e) setSearchOptions({ ...searchOptions, endDate: e.target.value })
                        }
                    }
                    placeholder={t("BILL_DATE_INPUT_PLACEHOLDER")}
                />
            </FormControl>
            <FormControl className="mx-2">
                <FormLabel>{t("FILTER_RESET")}</FormLabel>
                <Center>
                    <Button gap={2} onClick={(e) => { setSearchOptions(undefined) }}>
                        <RepeatClockIcon />
                        <Text>{t("RESET")}</Text>
                    </Button>
                </Center>
            </FormControl>
        </div>
    )
}

export default BillSelects;